<script setup>
import { ref } from "vue";
const siteAccess = ref(true);
</script>

<template>
  <div>
    <template v-if="siteAccess">
      <slot />
    </template>
  </div>
</template>
